export default class GeoProvider {
  state: Ref<GeoProviderState>
  private saveCallback: Function | null
  private overlay

  // TODO: Delete geolocation types from types folder when this class is removed
  // args will either be a string or nothing
  constructor() {
    const { $overlay } = useNuxtApp()
    this.overlay = $overlay

    // locationOverride is a way for us to override the displayed location in the modal
    //   - used for the installernet cart line item display
    this.state = useState<GeoProviderState>('geoprovider', () => ({
      locationOverride: null,
    }))

    this.saveCallback = null
  }

  get overrideFormattedLocation() {
    if (!this.state.value.locationOverride) return null

    const { city, region, zipcode } = this.state.value.locationOverride
    if (!city || !region || !zipcode) return 'Unknown location'

    return `${city}, ${region} ${zipcode}`
  }

  openModal(options: Partial<GeoProviderState['locationOverride'] & { cb: (location: UserLocation) => void }> = {}) {
    if (options) {
      const { cb, city, region, zipcode } = options
      if (cb) this.saveCallback = cb
      if (city || region || zipcode)
        this.state.value.locationOverride = {
          city: city ?? '',
          region: region ?? '',
          zipcode: zipcode ?? '',
        }
    }

    this.overlay.open('locationModal')
  }

  closeModal() {
    this.state.value.locationOverride = null
    this.saveCallback = null
    this.overlay.close()
  }
}
